import { z } from 'zod'
import { uuidCollectionSchema } from '@/types/global.ts'

export const fileSchema = z.string()

export type File = z.infer<typeof fileSchema>

export const fileCollectionSchema = uuidCollectionSchema(fileSchema)

export type FileCollection = z.infer<typeof fileCollectionSchema>
